<template>
  <div
    v-loading="loding"
    :element-loading-text="language('forgetPassword.placeholder5')"
  >
    <div>
      <!-- <el-card class="login-form" shadow="never"> -->
      <div class="form_wrap" id="form_wrap_disableAccount">
        <!-- <el-tabs v-model="activeName" stretch @tab-click="handleClick">
          <el-tab-pane label="手提電話" name="phone"></el-tab-pane>
          <el-tab-pane label="電郵" name="email"></el-tab-pane>
        </el-tabs> -->
        <el-form
          :model="loginForm"
          :rules="rules"
          status-icon
          ref="ruleForm"
          class="form"
          :label-width="locale_lang == 'en' ? '155px' : '82px'"
        >
          <el-form-item
            prop="applyType"
            :label="language('userData.tipsText67')"
          >
            <el-radio-group v-model="applyType">
              <el-radio label="stop">{{
                language("userData.tipsText68")
              }}</el-radio>
              <el-radio label="delete">{{
                language("userData.tipsText69")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            prop="activeName"
            :label="language('userData.tipsText70')"
          >
            <el-radio-group v-model="activeName" @change="handleClick">
              <el-radio label="phone">{{
                language("userData.tipsText71")
              }}</el-radio>
              <el-radio label="email">{{
                language("userData.tipsText72")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="code" :label="language('userInfo.serveTips9')">
            <el-input
              type="text"
              v-model="loginForm.code"
              :width="100"
              :placeholder="language('forgetPassword.placeholderCode')"
            >
              <div slot="append">
                <el-button
                  type="primary"
                  @click="getCode"
                  v-if="showGetCodebutton"
                  class="getCodeButton"
                  >{{ language("forgetPassword.getCodeText") }}</el-button
                >
                <el-button type="primary" v-if="!showGetCodebutton">{{
                  languageTC("forgetPassword.getCodeText2", timeText)
                }}</el-button>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha" :style="'margin-bottom:'+ (captchaWidth && showCaptcha?'18px':'0px')">
            <div class="captcha_wrap" v-if="captchaWidth && showCaptcha">
              <Captcha
                buttonId="login_button"
                @captchaVerifyCallback="captchaVerifyCallback"
                :captchaWidth="captchaWidth"
              ></Captcha>
            </div>
          </el-form-item>

          <el-form-item
            prop="reason"
            :label="language('userData.tipsText73')"
            v-if="applyType == 'delete'"
          >
            <el-input
              type="textarea"
              :rows="2"
              :placeholder="language('userData.tipsText74')"
              v-model="loginForm.reason"
              :autosize="{ minRows: 10, maxRows: 20 }"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width: 100%"
              @click="doForgetPassword"
              >{{ language("forgetPassword.submit") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- </el-card> -->
    </div>
  </div>
</template>

<script>
const checkPhone = require("../rules/checkPhone.js").mixin;
const checkEmail = require("../rules/checkEmail.js").mixin;
import Captcha from "./Captcha.vue";

export default {
  mixins: [checkPhone, checkEmail],
  components: { Captcha },

  data() {
    return {
      facebook: require("../file/icon/facebook.png"),
      google: require("../file/icon/google.png"),
      loding: false,
      area: "+852",
      loginForm: {
        name: "",
        code: "",
        type: "phone",
        reason: "",
      },
      rules: {
        code: [
          {
            required: true,
            message: this.language("forgetPassword.rulesCode"),
            trigger: "click",
          },
        ],
        reason: [
          {
            required: true,
            message: this.language("userData.tipsText74"),
            trigger: "click",
          },
        ],
        captcha: [{ validator: this.checkCaptcha, trigger: "blur" }],
      },
      showGetCodebutton: true,
      timeText: 60,
      activeName: "phone",
      applyType: "stop",
      verifyResult: {
        captchaResult: false,
        bizResult: "",
      },
      showCaptcha: false,
      captchaWidth: 437,
      timeR:null

    };
  },
  watch: {},
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
  },
  methods: {
    checkLoginName(rule, value, callback) {
      let text = "";
      if (this.loginForm.type == "phone") {
        text = this.checkPhone(this.area, this.loginForm.name);
      } else {
        text = this.checkEmail(this.loginForm.name);
      }
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkCaptcha(rule, value, callback) {
      if (this.verifyResult.captchaResult == false && this.showCaptcha) {
        callback(new Error(this.language("login.captchaText")));
      } else {
        callback();
      }
    },
    handleClick(o, n) {
      this.loginForm.type = this.activeName;
    },

    getCode() {
      this.$refs.ruleForm.validateField("captcha", (e2) => {
        if (e2 == "") {
          let data = {};
          if (this.loginForm.type == "phone") {
            data = {
              sendType: 1,
              applyType: this.applyType,
            };
          } else {
            data = {
              sendType: 0,
              applyType: this.applyType,
            };
          }
          if (this.verifyResult.captchaResult == true && this.showCaptcha) {
            data.captcha = this.verifyResult.captcha;
          }
          oauthSDK
            .getDisableAccountCode(data)
            .then((res) => {
              this.timeText = 60;
              this.countTime();
              this.showGetCodebutton = false;
              // this.verifyResult = {
              //   captchaResult: false,
              //   bizResult: "",
              // };
            })
            .catch((err) => {
              // this.defalutToast(err.message);
              if (err.code == 40003) {
                this.showCaptcha = true;
                this.verifyResult = {
                  captchaResult: false,
                  bizResult: "",
                };
              } else {
                this.defalutToast(err.message);
              }
              this.loding = false;
            });
        }
      });
    },
    countTime() {
      window.clearInterval(this.timeR);
      this.timeR = setTimeout(() => {
        this.timeText = this.timeText - 1;
        if (this.timeText > 0) {
          this.countTime();
        } else if (this.timeText == 0) {
          this.showGetCodebutton = true;
           window.clearInterval(this.timeR);
        }
      }, 1000);
    },
    doForgetPassword() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$confirm(
            this.applyType == "delete"
              ? this.language("deleteAccount.tipsText12")
              : this.language("userData.tipsText75"),
            this.applyType == "delete"
              ? this.language("userData.tipsText77")
              : this.language("userData.tipsText78"),
            {
              confirmButtonText: this.language("userData.tipsText34"),
              cancelButtonText: this.language("userData.tipsText64"),
              type: "warning",
            }
          )
            .then(() => {
              this.loding = true;
              if (this.applyType == "delete") {
                let data = {
                  code: this.loginForm.code,
                  reason: this.loginForm.reason,
                };
                oauthSDK
                  .deleteAccount(data)
                  .then((res) => {
                    this.loding = false;
                    // this.$message.success("提交申請成功");
                    this.$message.success(this.language("userData.tipsText79"));
                    // this.goToPage({ url: "login", query: {} });
                    // this.replacePage({ url: "login", query: {} });
                    this.replacePage({
                      url: this.$urlData.logoutURL,
                      query: {},
                    });
                  })
                  .catch((err) => {
                    this.user401(err);
                    this.defalutToast(err.message);
                    this.loding = false;
                  });
              } else {
                let data = {
                  code: this.loginForm.code,
                };
                oauthSDK
                  .disableAccount(data)
                  .then((res) => {
                    this.loding = false;
                    this.$message.success(this.language("userData.tipsText80"));
                    // this.goToPage({ url: "login", query: {} });
                    this.replacePage({
                      url: this.$urlData.logoutURL,
                      query: {},
                    });
                  })
                  .catch((err) => {
                    this.user401(err);
                    this.defalutToast(err.message);
                    this.loding = false;
                  });
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    captchaVerifyCallback(e) {
      this.verifyResult = e;
      this.getCode();
    },
  },
  mounted() {
    setTimeout(() => {
      this.captchaWidth = document.getElementById("disableAccount").offsetWidth;
    }, 2000);
  },
  created() {},
};
</script>

<style lang="scss"  scoped>
.form_wrap {
  width: 80%;
  margin: 0 auto;
}

.login-form {
  width: 600px;
  height: 390px;
}
</style>